module.exports = __webpack_public_path__ + "img/norimichi-system2.ac31d42a.png";